import React, { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const DEFAULT_LANG = 'es';
export const LANGS = ['es', 'en'];

// Slugs por página e idioma. El español (idioma por defecto) vive en la raíz
// y el inglés bajo el prefijo /en con slugs traducidos.
export const ROUTES = {
  home: { es: '/', en: '/en' },
  visibility: { es: '/visibility', en: '/en/visibility' },
  intelligence: { es: '/intelligence', en: '/en/intelligence' },
  documents: { es: '/documents', en: '/en/documents' },
  about: { es: '/sobre-nosotros', en: '/en/about' },
  contact: { es: '/contacto', en: '/en/contact' },
  privacy: { es: '/politica-privacidad', en: '/en/privacy-policy' },
};

export const langFromPath = (pathname) =>
  pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'es';

// Página canónica a la que corresponde un pathname (o null si no es una ruta conocida)
export const pageKeyFromPath = (pathname) => {
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const entry = Object.entries(ROUTES).find(
    ([, paths]) => paths.es === clean || paths.en === clean
  );
  return entry ? entry[0] : null;
};

const LanguageContext = createContext({
  lang: DEFAULT_LANG,
  path: (key) => (ROUTES[key] ? ROUTES[key][DEFAULT_LANG] : '/'),
  altPath: () => '/',
});

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const lang = langFromPath(location.pathname);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // Ruta de una página en el idioma activo
  const path = (key) => (ROUTES[key] ? ROUTES[key][lang] : ROUTES.home[lang]);

  // Ruta equivalente de la página actual en otro idioma (para el selector ES/EN)
  const altPath = (targetLang) => {
    const key = pageKeyFromPath(location.pathname);
    const base = key ? ROUTES[key][targetLang] : ROUTES.home[targetLang];
    return base + location.hash;
  };

  return (
    <LanguageContext.Provider value={{ lang, path, altPath }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

// Devuelve el bloque del idioma activo de un diccionario {es: {...}, en: {...}}
export const useT = (dict) => dict[useLang().lang];
